import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';

const Footer: React.FC = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#1E170B",
                color: 'white',
                py: 3,
                mt: 'auto',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography align="center" color='#443F35'
                        sx={{
                            fontFamily: "'Gantari', sans-serif",
                            fontWeight: 400,
                        }}
                    >
                        © {new Date().getFullYear()} Hendrik Grygas. All rights reserved.
                    </Typography>
                    <Link
                        href="/imprint-privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            color: '#443F35',
                            textDecoration: 'none',
                            fontSize: '0.75rem',
                            fontFamily: "'Gantari', sans-serif",
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Imprint & Privacy Policy
                    </Link>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;